import React from 'react';

import ContentLoader from '@adsk/alloy-react-content-loader';

const SuspenseFallback = () => (
  <ContentLoader width={300} height={36}>
    <rect x="0" y="0" rx="2" ry="2" width="300" height="36" />
  </ContentLoader>
);

export default SuspenseFallback;
